<template>
  <div>
    <label v-if="title" for="">{{ title }}</label>
    <div class="selector">
      <draggable :tag="'ul'" v-model="val">
        <li v-for="v in val" :key="v.id">
          <span>
            {{ v[selectKey] }}
          </span>
          <span v-if="!disabled" @click="clearItem(v.id)"> ✕ </span>
        </li>
      </draggable>
      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <list-item
      :modal="modal"
      v-model="val"
      :prefix="prefix"
      :disabled="disabled"
      :params="params"
      :pushLink="pushLink"
    />
  </div>
</template>
<script>
import draggable from "vuedraggable";
export default {
  data: () => ({
    // val: null,
  }),
  props: {
    pushLink: {
      default: "",
    },
    title: {
      default: "",
    },
    disabled: {
      default: false,
    },
    value: {
      default: "",
    },
    modal: {
      default: "",
    },
    selectKey: {
      default: "",
    },
    prefix: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
    draggable,
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }
      this.$modal.show(`${this.modal}${this.prefix}`);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
<style lang="scss">
.selector {
  position: relative;
  & > .background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  min-height: 35px;
  overflow: hidden;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  display: flex;
  width: 100%;
  background: #fff;
  align-items: center;
  text-align: left;
  margin-bottom: 20px;
  & > ul {
    list-style: none;
    padding: 0 0 0 5px;
    margin: 0;
    font-size: 16px;
    width: calc(100% - 40px);
    display: flex;
    flex-wrap: wrap;
    & > li {
      z-index: 9;
      margin: 3px;
      padding: 2px 5px 2px 5px;
      background: #222;
      color: #fff;
      border-radius: 4px;
      display: flex;
      align-items: center;
      & > span {
        cursor: pointer;
        display: block;
        font-size: 10px;

        &:last-child {
          font-size: 12px;
          line-height: 15px;
          margin-left: 5px;
          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }
  & > span {
    cursor: pointer;
    display: block;
    width: 40px;
    text-align: center;
    font-size: 16px;
    margin-right: auto;
  }
}
</style>